import { ChangeArrowDown, ChangeArrowUp } from "common/Icons/Icons";
import Text from "common/Typography/Text";
import React, { CSSProperties } from "react";
import { useTheme } from "styled-components";
import { toFixed } from "@shared/utils/numbers";
import { hexToRGB } from "@shared/utils/misc";

interface PriceChangeProps {
  change: number;
  size: number;
  useBackground?: boolean;
  isNeutral?: boolean;
  isAbsoluteValue?: boolean;
  style?: CSSProperties;
}

const PriceChange: React.FC<PriceChangeProps> = ({
  change,
  size,
  useBackground,
  isNeutral,
  isAbsoluteValue = true,
  style,
}) => {
  const appTheme = useTheme();
  const changeColor = isNeutral
    ? appTheme.colors.primaryBlue
    : change >= 0
    ? appTheme.colors.green
    : appTheme.colors.red;
  const backgroundColor =
    change >= 0
      ? hexToRGB(appTheme.colors.green, 0.1)
      : hexToRGB(appTheme.colors.red, 0.1);

  if (appTheme.isNewLook) {
    const sign = isNeutral || change === 0 ? "" : change > 0 ? "+" : "−";
    return (
      <Text
        style={{
          color: changeColor,
          background: useBackground ? backgroundColor : "",
          borderRadius: 6,
          padding: useBackground ? "1px 6px" : "",
          fontSize: size,
          fontWeight: appTheme.typography.fontWeights.MEDIUM,
          fontVariantNumeric: "tabular-nums",
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          ...style,
        }}
      >
        {sign}
        {toFixed(Math.abs(change), 2)}%
      </Text>
    );
  }

  return (
    <Text
      style={{
        color: changeColor,
        background: useBackground ? backgroundColor : "",
        borderRadius: 4,
        padding: useBackground ? "5px 4px" : "",
        fontSize: size,
        fontWeight: 500,
        display: "flex",
        alignItems: "center",
        lineHeight: 0,
        ...style,
      }}
    >
      {toFixed(isAbsoluteValue ? Math.abs(change) : change, 2)}%
      <span
        style={{
          fontSize: size - 5,
          marginLeft: 4,
        }}
      >
        {change < 0 ? <ChangeArrowDown /> : <ChangeArrowUp />}
      </span>
    </Text>
  );
};

export default PriceChange;
